<template>
    <div class="schedule-table">
        <table class="scheduleTable">
            <thead>
                <tr class="processed">
                    <th>Week</th>
                    <th>Maandag</th>
                    <th>Dinsdag</th>
                    <th>Woensdag</th>
                    <th>Donderdag</th>
                    <th>Vrijdag</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="weekNr" />
                    <td class="weekDay_1" />
                    <td class="weekDay_2" />
                    <td class="weekDay_3" />
                    <td class="weekDay_4" />
                    <td class="weekDay_5" />
                </tr>
                <tr>
                    <td class="weekNr" />
                    <td class="weekDay_1" />
                    <td class="weekDay_2" />
                    <td class="weekDay_3" />
                    <td class="weekDay_4" />
                    <td class="weekDay_5" />
                </tr>
                <tr>
                    <td class="weekNr" />
                    <td class="weekDay_1" />
                    <td class="weekDay_2" />
                    <td class="weekDay_3" />
                    <td class="weekDay_4" />
                    <td class="weekDay_5" />
                </tr>
                <tr>
                    <td class="weekNr" />
                    <td class="weekDay_1" />
                    <td class="weekDay_2" />
                    <td class="weekDay_3" />
                    <td class="weekDay_4" />
                    <td class="weekDay_5" />
                </tr>
                <tr>
                    <td class="weekNr" />
                    <td class="weekDay_1" />
                    <td class="weekDay_2" />
                    <td class="weekDay_3" />
                    <td class="weekDay_4" />
                    <td class="weekDay_5" />
                </tr>
                <tr>
                    <td class="weekNr" />
                    <td class="weekDay_1" />
                    <td class="weekDay_2" />
                    <td class="weekDay_3" />
                    <td class="weekDay_4" />
                    <td class="weekDay_5" />
                </tr>
            </tbody>
        </table>
        <div class="controls">
            <ui5-button id="previousDate" @click="shiftDateForSchedule(-1)">
                « Vorige
            </ui5-button>
            <div>Verlofdagen voor {{ dateForSchedule }}</div>
            <ui5-button id="nextDate" @click="shiftDateForSchedule(+1)">
                Volgende »
            </ui5-button>
        </div>
        <ui5-popover ref="popoverAbsences" id="popover-absences">
            <p style="font-weight: 600">Op verlof:</p>
            <ul id="leave-employee-list"></ul>
            <p id="leave-employee-list-title" style="font-weight: 600">
                Afwezig:
            </p>
            <ul id="absence-employee-list"></ul>
        </ui5-popover>
    </div>
</template>
<script>
import { getDaysInMonth, months } from '../../shared/schedule';
import employeeApi from '../../api/employee';
import moment from 'moment';
import _ from 'lodash';
import { getWeek } from '../../helpers/DateHelper';

export default {
    mounted() {
        this.initSchedule();
    },
    data() {
        return {
            dateForSchedule: '',
            monthForSchedule: '',
            yearForSchedule: '',
            leaveGroups: null,
            absenceGroups: null,
        };
    },
    methods: {
        initSchedule() {
            const date = new Date();
            const month = date.getMonth();
            const year = date.getFullYear();
            this.drawSchedule(month, year);
        },
        shiftDateForSchedule(direction) {
            const oldYear = this.yearForSchedule;
            const oldMonth = this.monthForSchedule;
            const newDate = new Date(
                oldYear,
                oldMonth + parseInt(direction),
                1
            );
            this.drawSchedule(newDate.getMonth(), newDate.getFullYear());
        },
        drawSchedule(month, year) {
            const self = this;

            this.dateForSchedule = months[month] + ' ' + year;
            this.monthForSchedule = month;
            this.yearForSchedule = year;

            const allDays = getDaysInMonth(month, year);
            const firstDay = allDays[0];
            const lastDay = allDays[allDays.length - 1];
            const formattedFirstDay = moment(firstDay).format('YYYY-MM-DD');
            const formattedLastDay = moment(lastDay).format('YYYY-MM-DD');

            const p1 = employeeApi
                .fetchAbsencesForRange(formattedFirstDay, formattedLastDay)
                .then((response) => {
                    this.absenceGroups = _.groupBy(
                        response.data.data || [],
                        (item) => {
                            return item.day;
                        }
                    );
                });
            const p2 = employeeApi
                .fetchAllLeaveForRange(formattedFirstDay, formattedLastDay)
                .then((response) => {
                    this.leaveGroups = _.groupBy(
                        response.data.data || [],
                        (item) => {
                            return item.day;
                        }
                    );
                });

            Promise.all([p1, p2]).then(() => {
                this.$el
                    .querySelectorAll('.schedule-table td, .schedule-table tr')
                    .forEach((element) => {
                        element.classList.remove('processed');
                        element.classList.remove('currentWeek');
                        element.removeAttribute('style');
                    });

                this.$el
                    .querySelectorAll('.schedule-table td .date')
                    .forEach((element) => {
                        element.innerHTML = '';
                    });

                this.$el
                    .querySelectorAll('.schedule-table td .time')
                    .forEach((element) => {
                        element.innerHTML = '';
                    });

                this.$el
                    .querySelectorAll('.schedule-table td.weekNr')
                    .forEach((element) => {
                        element.innerHTML = '';
                    });

                drawDays();

                const allKeys = _.uniq(
                    _.union(
                        _.keys(this.leaveGroups),
                        _.keys(this.absenceGroups)
                    ),
                    false
                );

                allKeys.forEach((key, index) => {
                    this.addItemsForDay(
                        this.leaveGroups[key] || [],
                        this.absenceGroups[key] || [],
                        key
                    );
                });

                function drawDays() {
                    allDays.forEach((date, index) => {
                        let day = date.getDay();
                        if (day == 0) {
                            day = 7;
                        }

                        const c1 = self.$el.querySelector(
                            '.schedule-table .weekDay_' +
                                day +
                                ':not(.processed)'
                        );
                        if (c1) {
                            const cell = c1.cloneNode(true);
                            c1.replaceWith(cell); //Remove event handlers

                            const weekNr = getWeek(date, 1);  // ISO 8601: weeks start on Monday (dowOffset = 1)
                            const weeknrCell =
                                cell.parentElement.querySelector('.weekNr');
                            if (weeknrCell.innerHTML == '') {
                                weeknrCell.innerHTML = weekNr;
                            }

                            const dateFormat =
                                moment(date).format('YYYY-MM-DD');
                            cell.innerHTML =
                                '<div id="day-' +
                                dateFormat +
                                '" class="date">' +
                                date.getDate() +
                                '</div>';
                            cell.classList.add('processed');
                            cell.parentElement.classList.add('processed');
                            cell.addEventListener(
                                'click',
                                generateClickHandler(dateFormat, cell)
                            );
                        }

                        if (index == 0) {
                            self.$el
                                .querySelectorAll(
                                    '.schedule-table tbody tr:first-child td'
                                )
                                .forEach((element, index) => {
                                    if (index < day) {
                                        element.classList.add('processed');
                                    }
                                });
                        }
                    });
                }
            });

            function generateClickHandler(date, cell) {
                return function () {
                    const popover = self.$el.querySelector('#popover-absences');

                    const leavesElement = self.$el.querySelector(
                        '#leave-employee-list'
                    );
                    const absencesElement = self.$el.querySelector(
                        '#absence-employee-list'
                    );
                    const absencesTitleElement = self.$el.querySelector(
                        '#leave-employee-list-title'
                    );

                    leavesElement.innerHTML = '';
                    absencesElement.innerHTML = '';
                    absencesTitleElement.style.display = 'none';

                    const leaves = self.leaveGroups[date] || [];
                    const absences = self.absenceGroups[date] || [];

                    const isGeneral = _.find(leaves, (o) => {
                        return o.employeeId == null;
                    });

                    if (isGeneral) {
                        leavesElement.innerHTML +=
                            '<li>Algemene verlofdag</li>';
                    } else if (leaves.length > 0) {
                        for (let i = 0; i < leaves.length; i++) {
                            const leave = leaves[i];
                            if (leave.employeeId) {
                                leavesElement.innerHTML +=
                                    '<li>' +
                                    leave.name +
                                    ': ' +
                                    leave.startTime +
                                    ' tot ' +
                                    leave.endTime +
                                    '</li>';
                            }
                        }
                    } else {
                        leavesElement.innerHTML += '<li>Geen verlofdagen.</li>';
                    }

                    if (absences.length > 0) {
                        absencesTitleElement.style.display = 'block';
                        for (let i = 0; i < absences.length; i++) {
                            absencesElement.innerHTML +=
                                '<li>' + absences[i].name + '</li>';
                        }
                    }

                    popover.showAt(cell);
                };
            }
        },
        addItemsForDay(leaves, absences, day) {
            const cellDay = this.$el.querySelector('#day-' + day);
            if (cellDay) {
                const leavesCount = leaves.length;
                const absencesCount = absences.length;
                const totalCount = leavesCount + absencesCount;

                const isGeneral = _.find(leaves, (o) => {
                    return o.employeeId == null;
                });

                if (isGeneral) {
                    cellDay.innerHTML += '<p>Algemene verlofdag</p>';
                } else if (leavesCount == 1) {
                    cellDay.innerHTML += '<p>' + leavesCount + ' verlofdag</p>';
                } else if (leavesCount > 1) {
                    cellDay.innerHTML +=
                        '<p>' + leavesCount + ' verlofdagen</p>';
                }

                if (absencesCount == 1) {
                    cellDay.innerHTML +=
                        '<p>' + absencesCount + ' afwezigheid</p>';
                } else if (absencesCount > 1) {
                    cellDay.innerHTML +=
                        '<p>' + absencesCount + ' afwezigheden</p>';
                }

                const parent = cellDay.parentElement;
                if (isGeneral) {
                    parent.style.backgroundColor = 'gold';
                } else {
                    if (totalCount > 0 && totalCount < 3) {
                        parent.style.backgroundColor = 'bisque';
                    } else if (totalCount > 2 && totalCount < 5) {
                        parent.style.backgroundColor = 'coral';
                    } else if (totalCount > 4) {
                        parent.style.backgroundColor = 'lightcoral';
                    }
                }
            }
        },
    },
};
</script>
